/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TasksControllerFindOneQueryResponse, TasksControllerFindOnePathParams, TasksControllerFindOneQueryParams, TasksControllerFindOne400, TasksControllerFindOne401, TasksControllerFindOne403, TasksControllerFindOne404 } from "../../models/tasksController/TasksControllerFindOne";

function getTasksControllerFindOneUrl(id: TasksControllerFindOnePathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/tasks/${id}` as const }  
  return res
}

/**
 * @summary Get a task by id
 * {@link /api/v1/tasks/:id}
 */
export async function tasksControllerFindOne(id: TasksControllerFindOnePathParams["id"], params?: TasksControllerFindOneQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TasksControllerFindOneQueryResponse, ResponseErrorConfig<TasksControllerFindOne400 | TasksControllerFindOne401 | TasksControllerFindOne403 | TasksControllerFindOne404>, unknown>({ method : "GET", url : getTasksControllerFindOneUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}